import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=f1eab984&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"
import style0 from "./Roles.vue?vue&type=style&index=0&id=f1eab984&prod&lang=scss&scoped=true"
import style1 from "./Roles.vue?vue&type=style&index=1&id=f1eab984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1eab984",
  null
  
)

export default component.exports